// extracted by mini-css-extract-plugin
export default {"quick":"Quick_quick__N4EOV","q_q_menu":"Quick_q_q_menu__EWPTT"};